import { Typography } from "@mui/material";
import * as React from "react";
import { useEffect } from "react";
import ApplicationStatusField from "./ApplicationStatusField";

const ApplicationBaseInfoHeader = ({ ...props }) => {
  const paramAppId = props.appId;
  let appId = paramAppId;
  let record = props.record;
  let isWaitProcess = "no";
  let appStatus = props?.appStatus;
  const isMounted = React.useRef(false);
  const renderCountRef = React.useRef(0);
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      renderCountRef.current += 1;
    }
  });
  if (appStatus == "New" || appStatus == "Check" || appStatus == "restart") {
    if (record?.showNextprocess == 1) {
      isWaitProcess = "no";
    } else {
      isWaitProcess = "yes";
    }
  } else if (appStatus == "Initial Review") {
    if (props?.requirementSaved == "yes") {
      isWaitProcess = "no";
    } else {
      isWaitProcess = "yes";
    }
  } else if (
    appStatus == "Approved" ||
    appStatus == "Completed" ||
    appStatus == "Countered" ||
    appStatus == "Pre-Approved" ||
    appStatus == "pre-approve" ||
    appStatus == "Closed"
  ) {
    let attachAttrs = record.attachAttrs;
    let borrowerAgreement = "";
    let showSwitchACH = false;
    let lenderaction = "";

    if (attachAttrs?.isAch == "NO") {
      if (attachAttrs?.executeStatus == "Closing Dos Received") {
        borrowerAgreement = "Signature Completed";
      } else {
        borrowerAgreement = "Pending Signature";
      }
    } else {
      if (attachAttrs?.payment_type == "NOTACH") {
        if (
          attachAttrs?.executeStatus == "Closing Dos Received" &&
          attachAttrs?.hasPaymentMethod
        ) {
          borrowerAgreement = "Signature Completed";
        } else {
          if (!attachAttrs?.hasPaymentMethod) {
            borrowerAgreement = "Pending ACH";
            showSwitchACH = true;
          }
          if (attachAttrs?.executeStatus != "Closing Dos Received") {
            if (!attachAttrs.hasPaymentMethod) {
              borrowerAgreement += ",";
            }
            if (attachAttrs?.executeStatus == "ID check failed") {
              borrowerAgreement += "Signature Failed";
            } else {
              borrowerAgreement += "Pending Signature";
            }
          }
        }
      } else {
        if (
          attachAttrs.executeStatus == "Closing Dos Received" &&
          attachAttrs.hasPaymentMethod
        ) {
          borrowerAgreement = "Signature Completed";
        } else {
          if (!attachAttrs.hasPaymentMethod) {
            borrowerAgreement = "Pending ACH";
            showSwitchACH = true;
          }
          if (attachAttrs.executeStatus != "Closing Dos Received") {
            if (!attachAttrs.hasPaymentMethod) {
              borrowerAgreement += ",";
            }
            if (attachAttrs.executeStatus == "ID check failed") {
              borrowerAgreement += "Signature Failed";
            } else {
              borrowerAgreement += "Pending Signature";
            }
          }
        }
      }
    }

    let showFinalizeButton = false;
    let showDisburseButton = false;
    let showDisburseOutHMButton = false;
    let showCompleteButton = false;

    if (
      borrowerAgreement.toLowerCase() == "completed" ||
      borrowerAgreement.toLowerCase() == "signature completed"
    ) {
      if (record.sSubType == "mortgage") {
        if (attachAttrs.fund_status != "FINALIZED") {
          lenderaction = "Finalize";
          showFinalizeButton = true;
        }
      } else {
        if (
          attachAttrs.payment_type == "ACH" ||
          attachAttrs.payment_type == "DISBURSEMENT"
        ) {
          if (
            attachAttrs.fund_status != "DISBURSEMENT_FUNDED" &&
            attachAttrs.fund_status != "COMPLETED" &&
            attachAttrs.disbursement_status != "no disbursement"
          ) {
            lenderaction = "show Disbursement";
            //disburse button should show
            if (record.sDisbursementPayment == "SMART_ACH_Vendor") {
              if (attachAttrs.vendorVerifyStatus == "Purchase Completed") {
                showDisburseButton = true;
              }
            } else {
              showDisburseButton = true;
            }
          }
          if (attachAttrs.disbursement_status == "no disbursement") {
            lenderaction = "Completed";
          }
        } else {
          lenderaction = "Disburse Funds";
          if (attachAttrs.disbursement_time != "inception") {
            lenderaction = "Completed";
          }
        }
      }
    }
    if (lenderaction == "") {
      lenderaction = "Completed";
    }

    // if borrowerAgreement have Pending Signature, Pending ACH, Signature Failed str, isWaitProcess = 'no'
    if (appStatus == "Approved" || appStatus == "Completed") {
      if (
        borrowerAgreement.search("Pending Signature") != -1 ||
        borrowerAgreement.search("Pending ACH") != -1 ||
        borrowerAgreement.search("Signature Failed") != -1
      ) {
        isWaitProcess = "yes";
      }
    }

    if (
      (appStatus == "Countered" || appStatus == "Pre-Approved") &&
      record.sApplicationResponse != "Accept"
    ) {
      isWaitProcess = "yes";
    }
  } else if (appStatus == "Hold") {
    isWaitProcess = "yes";
  }

  return (
    <>
      <Typography variant="h6" align="right">
        &nbsp;
        {/* appStatus : {appStatus}
        <br />
        isWaitProcess : {isWaitProcess}
        <br />
        showNextProcess : {record?.showNextprocess}
        <br />
        requirementSaved : {props?.requirementSaved}
        &nbsp; */}
      </Typography>
      <ApplicationStatusField
        activeStatus={appStatus}
        isWaitProcess={isWaitProcess}
        appId={appId}
        record={record}
      />
    </>
    // <Grid container >
    //     <Grid item xs={4} sx={{pt:'2.5rem'}}>
    //         <HmPageHeaderTitle title={`Application `+record.id} />
    //     </Grid>
    //     <Grid item xs={8}>
    //         <Typography variant="h6" align="right">&nbsp;</Typography>
    //         <ApplicationStatusField activeStatus={record.sStatus} />
    //     </Grid>
    // </Grid>
  );
};

export default ApplicationBaseInfoHeader;
